import React from "react";

const CreateFaq = () => {
  return <div>CreateFaq</div>;
};

export default CreateFaq;
